import $ from 'jquery';
import Framework from 'framework';
import _ from 'ext:lodash';
import selectorConfig from '../config.js';
import constants from 'lib/constants';
import moment from 'moment';

var toolTip = selectorConfig.dayPassToolTip;
var toolTipInfo = selectorConfig.dayPassToolTipInfo;
var toolTipLink = selectorConfig.dayPassToolTipLink;
var dayPassBalance = 0;
var dayPassTotal = 0;

export default class DayPassDial {
	constructor(profile) {
		this.profile = profile;
		this.daypassResources = null;
		this.allDaypassResources = null;
		this.dayPassUser = false;
		this.dayPassUserOnly = false;
		if(profile && profile.memberDetails && profile.memberDetails.resourceKeys && profile.memberDetails.resourceKeys.length > 0) {
			this.daypassResources = _.filter(profile.memberDetails.resourceKeys, (resource) => {
				return (resource.category === 'dayPass' && moment().isBefore(resource.thruDate));
			});
			this.allDaypassResources = _.filter(profile.memberDetails.resourceKeys, (resource) => {
				return (resource.category === 'dayPass');
			});
		}

		if((this.allDaypassResources && this.allDaypassResources.length > 0)
			|| (this.daypassResources && this.daypassResources.length > 0)) {
			this.dayPassUser = true;
			this.hasExpiration = false;
			if(this.profile.memberDetails.membershipLevelGroupName === 'Non-access') {
				this.dayPassUserOnly = true;
			}
		}
		this.content = '';
		if(this.daypassResources && this.daypassResources.length > 0) {
			var used = 0;
			var total = 0;
			_.forEach(this.daypassResources, function(resource) {
				used = used + resource.usageCount;
				total = total + resource.usageLimit;
			});
			var balance = 0;
			if(total >= used) {
				balance = total - used;
			}
			this.dayPassBalance = balance;
			this.dayPassTotal = total;
		}
	}

	sortExpirations(dirtyData) {
		var cleanedData = [].concat(dirtyData);

		cleanedData = _.orderBy(cleanedData, (expiration) => {
			return expiration.name;
		}, ['asc']);

		return cleanedData;
	}

	renderExpirations() {
		var profile = this.profile;
		var expirationsOutput = '';

		if(this.daypassResources && this.daypassResources.length > 0) {
			// sort the list
			let sortedDetails = this.sortExpirations(this.daypassResources);
			let expirations = sortedDetails.map((expiration)=> {
				var expirationString = '';
				var expLocalDate = moment(expiration.thruDate).local();
				var balance = expiration.usageLimit - expiration.usageCount;
				if(expLocalDate.isAfter(moment())) {
					var expFormattedDate = expLocalDate.format('L');
					var clubName = _.map(expiration.resources, function(item) {
						return item.name;
					}).join(', ');
					expirationString = `<p class='micro m-b-1'><strong>${clubName}</strong><br>${balance} Day Passes expire on ${expFormattedDate}</p>`;
				}
				return expirationString;
			}).join('');
			let buyMoreLink = `<a href='${Framework.global.lt.globalPageDrivers.global.dayPassBuyMoreJs}' target='_blank' class='daypass-buy-more-link'>Buy More</a>`;
			expirations = `<div class='text-xs-center'>${expirations}<p class='m-b-0'>${buyMoreLink}</p></div>`;

			this.hasExpiration = true;

			let expirationTemplate = `<div class="gauge-icon dayPassToolTip">
					<a href="#" role="button" class="dayPassToolTipLink" data-toggle="tooltip" data-trigger="click" data-prevent-default="true" data-placement="bottom" aria-describedby="dayPassInfo" data-original-title="${expirations}">
						<span class="ico-info-solid"></span>
					</a>
					<div class="sr-only dayPassToolTipInfo">
						${expirations}
					</div>
				</div>`;

			expirationsOutput = expirationTemplate;
		}
		return expirationsOutput;
	}

	updateDayPass() {
		var profile = this.profile;
		var expirationsToolTip = '';
		var gaugeText = '';

		//show hide items if the user has a profile
		if(this.dayPassBalance >= 1 && this.dayPassTotal > 0){
			// expirations to display
			expirationsToolTip = this.renderExpirations();

			// get the text for gauge
			gaugeText = `<div class="gauge-text">
				<div class="gauge-value">${this.dayPassBalance}<span class="small"> / ${this.dayPassTotal}</span></div>
				<div class="gauge-label">remaining</div>
			</div>
			`;
		}else{
			// display the buy more dial
			gaugeText = `<div class="gauge-text">
				<a href='${Framework.global.lt.globalPageDrivers.global.dayPassBuyMoreJs}' target='_blank' class='btn btn-primary btn-xs' onclick="event.preventDefault();LtFramework.openPartnerLink('${Framework.global.lt.globalPageDrivers.global.dayPassBuyMoreJs}','SSOID','true','false',this);">Buy More</a>
			</div>
			`;
		}

		this.content = `
		<div id="gaugeDayPasses" class="gauge gauge-daypass">
			<h6 class="gauge-header">Day Passes</h6>
			<div class="gauge-wrap">
				<div class="gauge-chrome">
					<div class="gauge-chrome">
						<svg class="gauge-svg" viewBox="0 0 120 120">
							<circle class="gauge-bg" cx="60" cy="60" r="57"  />
							<path class="gauge-indicator" d="M60,3c31.5,0,57,25.5,57,57s-25.5,57-57,57 S3,91.5,3,60S28.5,3,60,3z"/>
						</svg>
					</div>
				</div>
				${gaugeText}
				${expirationsToolTip}
			</div>
			<p class="gauge-link" style="display: none;"><a href="${Framework.global.lt.globalPageDrivers.account.dayPassHistory}">Details</a></p>
		</div>
		`;
	}
}
